export default "__VITE_ASSET__D5V8t7co__"